import React from "react";

const ContactInfo = ({
  name,
  setName,
  email,
  setEmail,
  mobile,
  setMobile,
  message,
  setMessage,
}) => {
  return (
    <div className="space-y-6 shadow-lg bg-dry dark:bg-neutral-900">
      <h2 className="text-2xl font-bold text-text  border-b border-border pb-4">
        Your Information
      </h2>

      {/* Name */}
      <div>
        <label className="block text-sm font-medium text-gray-400 mb-1">
          Full Name
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter your full name"
          className="w-full px-4 py-3 rounded-lg border border-border bg-none text-redlight placeholder-none focus:outline-none focus:ring-2 focus:ring-redlight"
        />
      </div>

      {/* Email */}
      <div>
        <label className="block text-sm font-medium text-gray-400 mb-1">
          Email Address
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="w-full px-4 py-3 rounded-lg border border-border bg-none text-redlight placeholder-none focus:outline-none focus:ring-2 focus:ring-redlight"
        />
      </div>

      {/* Mobile */}
      <div>
        <label className="block text-sm font-medium text-gray-400 mb-1">
          Mobile Number
        </label>
        <input
          type="tel"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          placeholder="+64 21 000 0000"
          className="w-full px-4 py-3 rounded-lg border border-border bg-none text-redlight placeholder-none focus:outline-none focus:ring-2 focus:ring-redlight"
        />
      </div>

      {/* Message / Notes */}
      <div>
        <label className="block text-sm font-medium text-gray-400 mb-1">
          Notes / Message
        </label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={4}
          placeholder="Add any special instructions or requests here..."
          className="w-full px-4 py-3 rounded-lg border border-border bg-none text-redlight placeholder-none focus:outline-none focus:ring-2 focus:ring-redlight"
        />
      </div>
    </div>
  );
};

export default ContactInfo;
